import axios from 'axios';
import ENDPOINTS from 'constants/endpoints';
import {
    utilizeCancelToken,
    checkResponseVersion,
    finalizeResponse,
    handleError
} from 'utils/api';

function getCategoryList(version) {
    const { cancel, cancelToken } = utilizeCancelToken('getCategoryList');
    if (cancel) cancel();
    return axios
        .get(ENDPOINTS.GET_CATEGORY_LIST, {
            cancelToken
        })
        .then(version ? checkResponseVersion(version) : response => response)
        .then(finalizeResponse())
        .catch(handleError());
}

export { getCategoryList };
